import { newRelicJSError } from '@nmx/utils/dist/utilities/frontend/Analytics/new_relic_helper';

export default function pinterestTrackLead() {
  try {
    pintrk('track', 'lead', {
      lead_type: 'Lead',
    });
  } catch (err) {
    const error = `Error firing Pinterest Lead Event Tag: ${err}`;
    newRelicJSError(error);
    console.error(error);
  }
}
